import { DecodeHtml } from '../../utils/decodeHtml'

const ResearchSection = ({ college }) => {
  const list = college?.mediaResearch_new?.items?.map(item => {
    item = item?.content?.properties
    return {
      title: item?.title,
      description: DecodeHtml({ html: item?.description?.markup })
    }
  })

  if (!list || list.length === 0) {
    return null
  }

  return (
    <div className='flex flex-col gap-8 p-4 md:px-10'>
      <h1 className='text-3xl font-bold '>Research</h1>
      <div className='grid grid-cols-1 xl:grid-cols-2 gap-5'>
        {list?.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col gap-5 w-full ${index == 0 ? 'xl:col-span-2' : ''}`}
          >
            <h2 className='text-xl font-semibold'>{item?.title}</h2>
           {item?.description}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ResearchSection
